export const homeTitle = "Jacque Menassa | Planejamento Estrat\u00e9gico";

export const homeDescription =
	"Jacque Menassa \u00e9 estrategista de planejamento, com experi\u00eancia em marcas como Natura, Havaianas, Vivo, Bauducco, Doriana e Protea, criando estrat\u00e9gias que conectam marcas e pessoas.";

export const siteName = "Jacque Menassa";
export const siteUrl = "https://www.jacquemenassa.com";
export const defaultOgImage = `${siteUrl}/assets/images/img-jacque.webp`;

export const keywords =
	"Jacque Menassa, Jacqueline Menassa, Jacque, Menassa, planejamento estrategico, strategic planning, estrategia, brand strategy, Havaianas, Natura, publicidade";

const caseImageBySlug: Record<string, string> = {
	"outubro-rosa": "/assets/images/cases/outubro-rosa/outubro-rosa-card.webp",
	"natura-homem-nos":
		"/assets/images/cases/natura-homem-nos/natura-homem-nos-card.webp",
	"webserie-havaianas":
		"/assets/images/cases/webserie-havaianas/webserie-havaianas-card.webp",
	"dia-das-maes-mmbb":
		"/assets/images/cases/dia-das-maes-mmbb/dia-das-maes-mmbb-card.webp",
	"alta-perfumaria":
		"/assets/images/cases/alta-perfumaria/alta-perfumaria-card.webp",
	"todas-as-flores":
		"/assets/images/cases/todas-as-flores/todas-as-flores-card.webp",
	"kaiak-sonar": "/assets/images/cases/kaiak-sonar/kaiak-sonar-card.webp"
};

export const buildCaseTitle = (caseTitle: string) =>
	`Jacque Menassa | ${caseTitle}`;

export const buildCaseDescription = (caseTitle: string) =>
	`Conhe\u00e7a o case ${caseTitle} no portf\u00f3lio de planejamento estrat\u00e9gico de Jacque Menassa.`;

export const buildCanonicalUrl = (path?: string) => {
	if (!path) return `${siteUrl}/`;
	const normalized = path.startsWith("/") ? path : `/${path}`;
	return `${siteUrl}${normalized}`;
};

export const getCaseOgImage = (slug?: string) =>
	slug && caseImageBySlug[slug]
		? `${siteUrl}${caseImageBySlug[slug]}`
		: defaultOgImage;

export const buildOgImageAlt = (caseTitle?: string) =>
	caseTitle ? `Case ${caseTitle} - Jacque Menassa` : "Jacque Menassa portrait";
